import React from 'react'

const ElemItemContaxto = ({id,nombre}) => {
    return (
        <li>
            <h3 id={id}>{nombre}</h3>
        </li>
    )
}

export default ElemItemContaxto
